import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import cameraRecording from "./VideoRecorder"
import VideoRecorder from './VideoRecorder';

function UploadFile() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <main className='contentarea'>
        <section className='selectlang'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                <div className='uploadFile useBorder'>
                  <div className="upload-btn-wrapper">
                    <a className="button orange btn" href="/audio/PassportPhotoMaker" style={{ fontSize: 26, borderRadius: 10, padding: "15px 30px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256">
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline points="86 82 128 40 170 82" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></polyline>
                        <line x1="128" y1="152" x2="128" y2="40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line>
                        <path d="M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></path>
                      </svg>
                      Upload Image
                    </a>
                    <input type="file" name="myfile" />
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6'>

                <div className='useBorder'>
                  <Button variant="primary" onClick={handleShow}>
                    Record
                  </Button>
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Recording</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-3 text-center'>
                      <VideoRecorder />
                      <br />
                      <Link to="/audio/AiDiscription">Video Details page</Link>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
            </div>
            <div className='mt-4'>
              <Button type='button' className='button green'>Submit</Button>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default UploadFile
